app.service('productTabOutlet', function(
	loading,
	pageConfig,
	sufficientOutletCategory,
	productSalesTabs
) {
	let $self;

	function getProductAvailability(huCode) {
		return $.ajax({
			method: 'GET',
			url: '/outletProduct-finder.ltr',
			data: { huCode }
		});
	}

	function showModal(outletProductId) {
		sufficientOutletCategory.showIndividualOffer(outletProductId);
	}

	function getErrorMessage() {
		return $.ajax({
			url: '/message-alert.ltr',
			data: {
				code: 'not-found-outlet-product-for-hu-code'
			}
		});
	}

	function onError() {
		getErrorMessage().then(message => {
			$('.sufficient-outlet-offer').prepend(message);
		});
	}

	function showIndividualOutletOffer(huCode) {
		loading.start();
		getProductAvailability(huCode)
			.then(showModal)
			.fail(onError)
			.always(() => {
				loading.stop();
			});
	}

	function init() {
		$self = $('#product-tabs');
	}

	return {
		init,
		showIndividualOutletOffer
	};
});
